(function(global) {
	var TRACK_ENDPOINT = "/track/video"; // <-- Laravel endpoint
	var PING_EVERY_MS = 15000;

	function makeSessionId() {
		return (
			Date.now().toString(36) +
			Math.random()
				.toString(36)
				.slice(2)
		);
	}

	function nowIso() {
		return new Date().toISOString();
	}

	function merge(objA, objB) {
		var out = {};
		var k;
		for (k in objA) if (objA.hasOwnProperty(k)) out[k] = objA[k];
		for (k in objB) if (objB.hasOwnProperty(k)) out[k] = objB[k];
		return out;
	}

	function send(payload) {
		payload.timestamp = nowIso();
		var body = JSON.stringify(payload);

		// Fallback: fetch if available, else XHR
		var csrfEl = document.querySelector('meta[name="csrf-token"]');
		var csrf = csrfEl ? csrfEl.getAttribute("content") : null;

		if (window.fetch) {
			var headers = { "Content-Type": "application/json" };
			if (csrf) headers["X-CSRF-TOKEN"] = csrf;

			fetch(TRACK_ENDPOINT, {
				method: "POST",
				headers: headers,
				credentials: "same-origin",
				keepalive: true,
				body: body,
			})["catch"](function() {});
			return;
		}

		// XHR fallback (for very old browsers)
		try {
			var xhr = new XMLHttpRequest();
			xhr.open("POST", TRACK_ENDPOINT, true);
			xhr.setRequestHeader("Content-Type", "application/json");
			if (csrf) xhr.setRequestHeader("X-CSRF-TOKEN", csrf);
			xhr.send(body);
		} catch (e2) {}
	}

	function attachToPlayer(player, ctx) {
		var sessionId = makeSessionId();
		var pingTimer = null;
		var hasStarted = false;

		function currentTimeSeconds() {
			try {
				if (player && typeof player.getCurrentTime === "function") {
					var t = player.getCurrentTime();
					return Math.floor(t || 0);
				}
			} catch (e) {}
			return null;
		}

		function basePayload(extra) {
			return merge(
				{
					lesson_id: ctx.lesson_id,
					video_id: ctx.video_id,
					video_src: ctx.video_src || null,
					session_id: sessionId,
					video_time_seconds: currentTimeSeconds(),
				},
				extra || {},
			);
		}

		function startPing() {
			if (pingTimer) return;
			pingTimer = setInterval(function() {
				// MediaElement sets player.paused boolean
				if (player && player.paused === false) {
					send(basePayload({ event_type: "ping" }));
				}
			}, PING_EVERY_MS);
		}

		function stopPing() {
			if (pingTimer) clearInterval(pingTimer);
			pingTimer = null;
		}

		// Bind to underlying media element
		var $media = $(player.media);

		// Avoid duplicates on reopen
		$media.off(".vidtrack");

		$media.on("play.vidtrack", function() {
			if (!hasStarted) {
				hasStarted = true;
				send(basePayload({ event_type: "start" }));
			}
			startPing();
		});

		$media.on("pause.vidtrack", function() {
			send(basePayload({ event_type: "pause" }));
			stopPing();
		});

		$media.on("ended.vidtrack", function() {
			send(basePayload({ event_type: "ended" }));
			stopPing();
		});

		$media.on("seeking.vidtrack", function() {
			send(basePayload({ event_type: "seek" }));
		});

		// Return cleanup function for popup close
		return function cleanup() {
			stopPing();

			// final ping on close (optional)
			if (hasStarted) {
				send(basePayload({ event_type: "ping" }));
			}

			$media.off(".vidtrack");
		};
	}

	global.VideoTracker = {
		attachToPlayer: attachToPlayer,
	};
})(window);
